<template>
  <teamWorkerModal
    v-model:open="store.teamWorkerModalVisible"
    @asyncSuccess="teamWorkerModalSuccess"
  />
  <newFolder v-model:open="store.newFolderVisible" @asyncSuccess="newFolderModalSuccess" />
  <sortFolder v-model:open="store.sortFolderVisible" @asyncSuccess="sortFolderModalSuccess" />
  <copyFolder v-model:open="store.copyFolderVisible" @asyncSuccess="copyFolderModalSuccess" />
  <moveFolder v-model:open="store.moveFolderVisible" @asyncSuccess="moveFolderModalSuccess" />
  <deleteFolder v-model:open="store.deleteFolderVisible" @asyncSuccess="deleteFolderModalSuccess" />
  <shareFolder v-model:open="store.shareFolderVisible" @asyncSuccess="shareFolderModalSuccess" />
</template>

<script setup>
import teamWorkerModal from './teamWorkerModal'
import newFolder from './newFolder'
import sortFolder from './sortFolder'
import copyFolder from './copyFolder'
import moveFolder from './moveFolder'
import deleteFolder from './deleteFolder'
import shareFolder from './shareFolder'
import { aigcStore } from '@/store/aigcStore'

const emits = defineEmits('success')
const store = aigcStore()

const teamWorkerModalSuccess = () => {
  store.closeTeamWorkerModal()
}
const newFolderModalSuccess = () => {
  store.closeNewFolderModal()
  emits('success')
}
const sortFolderModalSuccess = () => {
  store.closeSortFolderModal()
}
const copyFolderModalSuccess = () => {
  store.closeCopyFolderModal()
}
const deleteFolderModalSuccess = () => {
  store.closeDeleteFolderModal()
}
const moveFolderModalSuccess = () => {
  store.closeMoveFolderModal()
}
const shareFolderModalSuccess = () => {
  // store.closeShareFolderModal()
}
</script>

<style lang="less" scoped></style>
